import { render, staticRenderFns } from "./BatchProcessingList.vue?vue&type=template&id=9c87d73e"
import script from "./BatchProcessingList.vue?vue&type=script&lang=js"
export * from "./BatchProcessingList.vue?vue&type=script&lang=js"
import style0 from "./BatchProcessingList.vue?vue&type=style&index=0&id=9c87d73e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c87d73e')) {
      api.createRecord('9c87d73e', component.options)
    } else {
      api.reload('9c87d73e', component.options)
    }
    module.hot.accept("./BatchProcessingList.vue?vue&type=template&id=9c87d73e", function () {
      api.rerender('9c87d73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BatchProcessingList.vue"
export default component.exports